// extracted by mini-css-extract-plugin
export default {"splashPage":"ExampleSplash_splashPage__kDTS4","btnContainer":"ExampleSplash_btnContainer__P93Px","exampleBtn":"ExampleSplash_exampleBtn__vtNoC"};